import { useMemo } from "react"
import { useSelector } from "react-redux"
import { useParams, useSearchParams } from "react-router-dom"
import { widgetCartItemsSelector } from "store/experiences"
import { CART_ITEM_QUERY, CART_ONLY_ITEM_FIELDS } from "../../constants"

// The cart item this experience page is changing ("Choose another time", ?item=<cartId>), with its
// choices to start the panel from (`selection`, without the cart's own fields). Null when the page
// adds a new item, or the item isn't this experience's (any more) in the cart.
const useCartItemBeingChanged = () => {
  const { id } = useParams()
  const [searchParams] = useSearchParams()
  const items = useSelector(widgetCartItemsSelector)
  const cartId = searchParams.get(CART_ITEM_QUERY)
  const item = items.find((cartItem) => cartItem.cartId === cartId && cartItem.experienceId === id) || null
  const selection = useMemo(
    () => (item ? Object.fromEntries(Object.entries(item).filter(([field]) => !CART_ONLY_ITEM_FIELDS.includes(field))) : null),
    [item]
  )
  return { cartId: item?.cartId ?? null, selection }
}

export default useCartItemBeingChanged
